import React, {useEffect, useState} from "react";
import axios from "axios";

const FranchisesInCountries = () => {

  const [allBrands, setAllBrands] = useState([]);
  const [countries, setCountries] = useState([]);
  const [selectedCountryId, setSelectedCountryId] = useState(0);
  const [brandsInCountry, setBrandsInCountry] = useState([]);
  const [selectedBrandIndex, setSelectedBrandIndex] = useState(0);
  const [selectedBrandRow, setSelectedBrandRow] = useState(0);
  const [selectedBrandData, setSelectedBrandData] = useState({});


  useEffect(() => {
    getBrandsAndCountries();
  }, []);

  useEffect(() => {
    if (brandsInCountry.length > 0) {
      collectSelectedBrandData(0, 0, brandsInCountry[0].id);
    }
  }, [brandsInCountry])

  function getBrandsAndCountries() {

    const brandsUrl = "/api/taxonomy/brands";
    const countriesUrl = "/api/taxonomy/countries";
    let brands;
    let countries;

    const brandsRequest = axios.get(brandsUrl);
    const countriesRequest = axios.get(countriesUrl);

    axios.all([brandsRequest, countriesRequest]).then(axios.spread((...responses) => {
      let countryId;

      brands = responses[0].data;
      countries = responses[1].data;
      countryId = countries[0].id;
      setAllBrands(brands);
      setCountries(countries);
      setSelectedCountryId(countryId)
      getBrandsInCountry(countryId);
    })).catch(errors => {
      console.error(errors);
    })
  }

  function createCountryOptions(countries) {
    let options = [];

    for (let c = 0; c < countries.length; c++) {
      options.push(<option value={countries[c].id} key={"country" + c}>{countries[c].name}</option>);
    }
    return options;
  }

  function getBrandInfoById(id, desc) {
    let brand;
    let obj;
    brand = allBrands.filter(element => {
      return element.id === id
    })[0];

    obj = {
      name: brand.name,
      url: brand.field_brand_logo[0].url,
      desc: desc
    }

    return obj;
  }

  function getBrandsInCountry(countryId) {
    axios
      .get(`/api/taxonomy/brands_in_countries?field_country=${countryId}`)
      .catch(error => {
        console.error(error);
      })
      .then(resp => {
        if (resp && resp.status === 200) {
          setBrandsInCountry(filterBrandsInCountry(resp.data));
        } else {
          console.error("No data");
        }
      })
  }

  function filterBrandsInCountry(brands) {
    let filtered = [];
    for(let b = 0; b < brands.length; b++ ) {
      if(brands[b].field_franchise_info.length > 0) {
        filtered.push(brands[b]);
      }
    }
    return filtered;
  }

  function handleChangeCountry(event) {
    let countryId = event.target.value;
    setSelectedCountryId(countryId);
    getBrandsInCountry(countryId);
  }

  function handleSelectBrand(event) {
    let wrapper = event.target.closest('.brand-wrapper');
    let index = parseInt(wrapper.getAttribute('data-index'));
    let row = parseInt(wrapper.getAttribute('data-row'));
    let brandInCountryId = wrapper.getAttribute('data-brand-in-country-id');

    collectSelectedBrandData(index, row, brandInCountryId);
  }

  function collectSelectedBrandData(brandIndex, row, brandInCountryId) {
    setSelectedBrandIndex(brandIndex);
    setSelectedBrandRow(row);
    setSelectedBrandData({
      [row]: getBrandNameAndDesc(brandInCountryId)
    });
  }

  function getBrandNameAndDesc(brandInCountryId) {
    let obj = {};
    let brand = brandsInCountry.filter(el => {
      return el.id === brandInCountryId
    })[0];
    let brandId = brand.field_brand[0].target_id;

    obj.desc = brand.field_franchise_info[0].value;

    obj.name = allBrands.filter(element => {
      return element.id === brandId
    })[0].name;

    return obj;
  }

  function createBrandsContainers(brandsToBeDisplayed) {
    let list = [];
    let brand;
    let brandInfo;
    let brandsPerRow = 3;
    let row;
    for (let b = 0; b < brandsToBeDisplayed.length; b++) {
      brand = brandsToBeDisplayed[b];
      brandInfo = getBrandInfoById(brand.field_brand[0].target_id, brand.field_franchise_info[0].value);
      row = Math.floor(b / brandsPerRow)
      list.push(
        <div className="brand-wrapper col-4 mb-4"
             key={"brand" + b}
             data-row={row}
             data-index={b}
             data-selected={selectedBrandIndex === b}
             data-brand-in-country-id={brand.id}
             data-brand-id={brand.field_brand[0].target_id}
             onClick={handleSelectBrand}
        >
          <div className="brand p-3 d-flex align-content-center justify-content-center border">
            <img className="img-fluid" src={brandInfo.url} alt="brand logo"/>
          </div>
        </div>)
      // add desc wrapper after each "brandsPerRow" items
      if (b > 1 && brandsPerRow % b === 1) {
        list.push(createBrandDescContainer(row, b))
      }
    }
    //because last non full-filled row also should have desc container
    if (brandsPerRow % (brandsToBeDisplayed.length - 1) !== 1) {
      list.push(createBrandDescContainer(row, brandsToBeDisplayed.length))
    }

    return list;
  }

  function createBrandDescContainer(row, key) {
    return <div className={"col-12 desc-wrapper mb-4" + (row === selectedBrandRow ? "" : " empty")} data-row={row} key={"brand-desc-container" + key}>
      <p className="name font-family-roboto-slab color-text-orange font-size-12rem font-weight-bolder">
        {selectedBrandData[row] ? selectedBrandData[row].name : ''}
      </p>
      <div className="desc font-size-95rem mb-0"
       dangerouslySetInnerHTML={{__html: (selectedBrandData[row] ? selectedBrandData[row].desc : '')}}
      />
    </div>
  }

  return (
    <>
        <div className="col-12 mt-4 mb-4">
          <form className="form-inline">
            <div className="form-group row">
              <label className="col-form-label font-weight-bold color-text-gray">Country:</label>
              <div className="col-sm-5">
                <select className="form-control"
                        onChange={handleChangeCountry}
                        value={selectedCountryId}
                >
                  {createCountryOptions(countries)}
                </select>
              </div>
            </div>
          </form>
        </div>
        <div className="row brands">
          {createBrandsContainers(brandsInCountry)}
        </div>
    </>
  );
};

export default FranchisesInCountries;
